
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./verifone.cjs.production.min.js')
} else {
  module.exports = require('./verifone.cjs.development.js')
}
